export class VesselDetailsModel {

  constructor(masterData, vesselData, vesselMstId, disabled, isEnrollVessel, regulations) {
    this.masterData = masterData;
    this.vesselData = vesselData;
    this.vesselMstId = vesselMstId;
    this.disabled = disabled;
    this.isEnrollVessel = isEnrollVessel;
    this.regulations = regulations;
  }

  fromBaseData(baseData) {
    this.masterData = baseData.masterData;
    this.vesselData = baseData.vesselData;
    this.vesselMstId = baseData.vesselMstId;
    this.disabled = baseData.disabled;
    this.isEnrollVessel = baseData.isEnrollVessel;
    this.regulations = baseData.regulations;
  }

}

export class ManagementSubmitterFormGroupModel extends VesselDetailsModel {

    constructor(baseModel, disableRiskAssessment) {
      super().fromBaseData(baseModel);

      this.disableRiskAssessment = disableRiskAssessment;
    }
  
  }

export class VesselIdentificationFormGroupModel extends VesselDetailsModel {

  constructor(baseModel, imoBasedData, setImoBasedData) {
        super().fromBaseData(baseModel);

        this.imoBasedData = imoBasedData;
        this.setImoBasedData = setImoBasedData;
  }

}

export class VesselParticularsFormGroupModel extends VesselDetailsModel {

    constructor(baseModel, imoBasedData, setSumofMainEnginePowers, sumofMainEnginePowers, setSumofAuxEnginePowers, sumofAuxEnginePowers,) {
        super().fromBaseData(baseModel);

        this.imoBasedData = imoBasedData;
        this.setSumofMainEnginePowers = setSumofMainEnginePowers;
        this.sumofMainEnginePowers = sumofMainEnginePowers;
        this.setSumofAuxEnginePowers = setSumofAuxEnginePowers;
        this.sumofAuxEnginePowers = sumofAuxEnginePowers;
    }
  
  }

  export class ConsumerRegistryFormGroupModel extends VesselDetailsModel {

    constructor(baseModel, setSumofMainEnginePowers,isReportTab) {
        super().fromBaseData(baseModel);
  
        this.setSumofMainEnginePowers = setSumofMainEnginePowers; 
        this.isReportTab = isReportTab;
    }
  
  }

  export class FuelRegistryFormGroupModel extends VesselDetailsModel {

    constructor(baseModel, setSumofAuxEnginePowers,isReportTab) {
        super().fromBaseData(baseModel);
  
        this.setSumofAuxEnginePowers = setSumofAuxEnginePowers;
        this.isReportTab = isReportTab;
    }
  
  }

  export class UKMETSFormGroupModel extends VesselDetailsModel {

    constructor(baseModel,reportStatus) {
      super().fromBaseData(baseModel);
      this.reportStatus = reportStatus;
    }

}